import { get, post } from '../config/$ajax.js'
import { getErpHost } from '@/utils/domainHelper.js';



// 待出货采购商数据汇总
// - 参数:
//     - distributorLevel: 分销等级 0.全部  1.1级  2.2级  3.3级   4.4级   5.5级
//     - distributorName:  模糊搜索 采购商名称
export const queryTakenOrderSumInfo = (data = {}, params = {}) => {
  return post('/scm/caigou/takenOrder/queryTakenOrderSumInfo', data, { submitType: 'json', ...params });
}

// 采购商待拿、待退商品统计数据
// - 参数:
//     - distributorLevel: 分销等级 0.全部  1.1级  2.2级  3.3级   4.4级   5.5级
//     - distributorName:  模糊搜索 采购商名称
//     - pageNo:  
//     - pageSize:  
export const queryTakenOrderInfoPage = (data = {}, params = {}) => {
  return post('/scm/caigou/takenOrder/queryTakenOrderInfoPage', data, { submitType: 'json', ...params });
}

// 查询单个 采购商待拿、待退商品统计数据
// - 参数:
//     - distributorCompanyId:  采购商公司id
export const queryTakenOrderInfo = (data = {}, params = {}) => {
  return get('/scm/caigou/takenOrder/queryTakenOrderInfo', data, params);
}

// 统计供应商下，商品维度待拿、待退金额、数量，及标签已打印次数
// - 参数:
//     - distributorCompanyId:  采购商公司id
//     - isSkuMatched:  商品是否匹配 1-是，0-否
//     - isSkuMatched:  拿货价是否待审核  0：是 1：否
//     - outerIdList:  款式编码 集合形式传递
//     - itemOuterIdList:  商品编码 集合形式传递
//     - text:  查询关键字
//     - pageNo:  
//     - pageSize:  
export const queryTakenOrderDetailInfo = (data = {}, params = {}) => {
  return post('/scm/caigou/takenOrder/queryTakenOrderDetailInfo', data, { submitType: 'json', ...params });
}

// 统计商品改价次数
export const countPriceChangeApprovalRecord = (data = {}, params = {}) => {
  return post('/scm/caigou/takenOrder/countPriceChangeApprovalRecord', data, { submitType: 'json', ...params });
}


// 提交供货价改价审核（统一售价或按当前价格调整，△商品维度） 场景：改供货价
// - 参数:
//     - distributorCompanyId:  采购商公司id 
//     - priceChangeApprovalRecordList:  [{purchaseOrderIdList:[],sourceType, supplierId, sysItemId, sysSkuId, approvalAfterPrice}]
export const addPriceChangeApprovalRecord = (data = {}, params = {}) => {
  return post('/scm/caigou/takenOrder/addPriceChangeApprovalRecord', data, { submitType: 'json', ...params });
}

// 查询商品改价记录（支持状态筛选）场景：查询商品改价记录
// - 参数:
//     - distributorCompanyId:  采购商公司id
//     - approvalStatusList: [] 审批状态list 0:“待审批”、1:“已通过”、2:“已拒绝”
//     - sourceType:  单据来源  0：app、1：小程序、2：PDA、3：快麦通
//     - queryTimeType:  查询时间范围类型 0：申请时间  1：审批时间
//     - searchStartTime:  开始时间
//     - searchEndTime:  结束时间
//     - pageNo:  
//     - pageSize:  
export const priceChangeApprovalRecordList = (data = {}, params = {}) => {
  return post('/scm/caigou/takenOrder/priceChangeApprovalRecordList', data, { submitType: 'json', ...params });
}

// 获取采购配置
export const queryPurchaseConfig = (data = {}, params = {}) => {
  return get('/scm/caigou/takenOrder/queryPurchaseConfig', data);
}

// 查询采购商信息
export const detailInfo = (data = {}, params = {}) => {
  return get('/scm/caigou/purchase/detailInfo', data);
}

// 手动绑定供分销商品关系
export const saveFxRelation = (data = {}, params = {}) => {
  return post('/scm/caigou/purchase/saveFxRelation', data, { submitType: 'json', ...params });
}

// 查询采购商信息
export const queryCgShareUrl = (data = {}, params = {}) => {
  return get('/scm/caigou/purchase/getCgShareUrl', data);
}

// 查询采购商list
export const queryPurchaserPageList = (data = {}, params = {}) => {
  return get('/scm/caigou/purchase/queryPurchaserPageList', data);
}

// 采购外链登录
export const caigouOuterLinkLogin = (data = {}, params = {}, hostUrl) => {
  return post(`${hostUrl}/caigou/noVistor/order/V2/login`, data);
}





